import React, { useState, useEffect } from 'react';
import { Dialog, Grid, Grow, Icon, IconButton, InputBase, makeStyles, TextField, Typography } from '@material-ui/core';
import RequestPhoneCode from './components/RequestPhoneCode';
import useBalanceModal from './useBalanceModal';
import CodeVerification from './components/CodeVerification';
import ResetPassword from './components/ResetPassword';
import Congratulations from './components/Congratulations';
import { blueGrey, green, grey } from '@material-ui/core/colors';
import RoundedButton from '../../components/Actions/RoundedButton';
import DisplayError from '../../components/DisplayError';
import iconImage from '../../assets/images/slotMachine.png'
import cx from 'classnames'
const BalanceModal = (props) => {

    const classes = useStyles()
    const {open, onClose, cardholder} = props
    const {system, actions, view_data} = useBalanceModal({open, cardholder, onClose})

    const {success, mode} = view_data

    let contentView = (
        <div>
            <Typography variant='h5' style={{fontWeight:500}} color='primary'>{cardholder?.firstName} {cardholder?.lastName}</Typography>
            <div className={classes.balance_container}>
                <Grid container direction='column' alignItems='center'>
                    <Grid item >
                        <Typography>Balance</Typography>
                    </Grid>
                    <Grid item>
                        <div>
                            <Typography className={classes.balance_cash}>{`$${view_data.originalBalance}`}</Typography>
                        </div>
                    </Grid>
                </Grid>
            </div>
            <div style={{padding:'16px 0px'}}>
                <Grid container justify='center' alignItems='center' spacing={2}>
                    <Grid item>
                        <div className={classes.image_container}>
                            <img src={iconImage} alt='' className={classes.image}/>
                        </div>
                    </Grid>
                    <Grid item>
                        <Grid container justify='center' alignItems='center' spacing={1}>
                            <Grid item >
                                <Typography style={{fontSize:'2.5rem'}}>$</Typography>
                            </Grid>
                            <Grid item>
                                <div className={classes.input_container}>                                
                                    <InputBase 
                                        className={classes.input}
                                        value={view_data.balance} 
                                        onChange={actions.onUpdateBalance}
                                        onBlur={actions.onBlur}
                                        placeholder='0'
                                        fullWidth 
                                        type='number'
                                        style={{fontSize:'2.5rem', textAlign:'center'}} 
                                        inputProps={{
                                            style:{textAlign:'center'}
                                        }} 
                                    />
                                    
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                    
                    <Grid item>
                        <Grid container direction='column' spacing={1}>
                            <Grid item>
                                <IconButton size='small' className={
                                    cx({
                                        [classes.icon_button]:true,
                                        [classes.icon_button_enable]:mode === 1,
                                    })
                                }
                                onClick={actions.onIncrement}><Icon>add</Icon></IconButton>
                            </Grid>
                            <Grid item>
                                <IconButton size='small' className={
                                     cx({
                                        [classes.icon_button]:true,
                                        [classes.icon_button_enable]:mode === -1,
                                    })
                                }
                                onClick={actions.onDecrement}><Icon>remove</Icon></IconButton>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
            <div style={{marginTop:32}}>
                <Grid container justify='center' alignItems='center' direction='column' spacing={2}>
                    
                    <Grid item>
                        <RoundedButton size='big' loading={system.sending} onClick={actions.onSubmit}>UPDATE</RoundedButton>
                    </Grid>
                    {system.error ? <Grid item>
                        <DisplayError >{system.error}</DisplayError>
                    </Grid> : null}
                </Grid>
            </div>
            
        </div>
    )

    const successContent = (
        <div>
            <Grow in>
                <div>
                    <Grid container direction='column' alignItems='center'>
                        <Grid item>
                            <div className={classes.icon_container}>
                                <Icon className={classes.checkIcon}>
                                    check
                                </Icon>
                            </div>
                        </Grid>
                        <Grid item>
                            <Typography color='textSecondary' variant='body1' style={{fontSize:'1.125rem'}}>You've {mode === 1 ? 'added' : 'removed'} <strong>${view_data.balance??'0.00'}</strong></Typography>
                        </Grid>
                        <Grid item>
                            <div style={{marginTop:32}}>
                                <RoundedButton onClick={actions.onReturn}>Continue</RoundedButton>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </Grow>
            
        </div>
    )

    return ( 
        <Dialog open={open} maxWidth='sm' fullWidth classes={{ paper: classes.paper }} className={classes.root}
        TransitionComponent={Transition} onClose={onClose} scroll='body'>
            <div className={classes.root}>
                <IconButton className={classes.close_button} onClick={onClose} ><Icon>close</Icon></IconButton>
                {!success ? contentView : successContent}
            </div>
        </Dialog>
     );
}

const useStyles = makeStyles(theme => ({
    input:{
        '& input[type=number]': {
            '-moz-appearance': 'textfield'
        },
        '& input[type=number]::-webkit-outer-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0
        },
        '& input[type=number]::-webkit-inner-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0
        }
    },
    paper:{
        borderRadius:32, 
        padding:theme.spacing(5),
        position:'relative',
        [theme.breakpoints.down('sm')]:{
            padding:theme.spacing(3),
            margin:8
        },
        
    },
    balance_container:{
        padding:'32px 0px'
    },
    balance_cash:{
        fontWeight:'500',
        fontSize:'2rem'
    },
    image_container:{
        width:72,
        height:72,
        marginRight:16
    },
    image:{
        width:'100%',
        height:'100%',
        objectFit:'contain'
    },
    root:{
    },
    icon:{
        //color:'white',
        borderRadius:'50%',
        fontSize:54,
        padding:8
    },
    close_button:{
        position:'absolute', right:16, top:16
    },
    input_container:{
        width:200,
        padding:'8px 0px',
        borderRadius:12,
        border:`1px solid ${grey[300]}`,
        [theme.breakpoints.down('sm')]:{
            width:150,
        }
    },
    icon_button:{
        background:'transparent',
        border:`1px solid ${theme.palette.primary.main}`,
        color:theme.palette.primary.main,
        '&:hover':{
            background:'transparent',
        }
    },
    icon_button_enable:{
        background:theme.palette.primary.main,
        color:'white',
        '&:hover':{
            background:theme.palette.primary.dark,
        }
    },
    icon_container:{
        width:90,
        height:90,
        border:`2px solid ${green[300]}`,
        background:green[100],
        borderRadius:'50%',
        position:'relative',
        position:'relative',
        marginTop:40,
        marginBottom:40,
    },
    checkIcon:{
        position:'absolute',
        top:'50%', left:'50%',
        transform:'translate(-50%, -50%)',
        fontSize:48,
        color:green[700]
    }
}))
 
export default BalanceModal;

const Transition = React.forwardRef(function Transition(props, ref) {return <Grow ref={ref} {...props} timeout={500} />;});
